import { useMediaQuery } from 'usehooks-ts';

import { Box } from '@mui/material';

import Header from '../header/header';
import Footer from '../footer/footer';
import NewFooter from '../new-footer/new-footer';
import type { NewFooterProps } from '../new-footer/types';
import VerticalFooter from '../vertical-footer/vertical-footer';

type Props = {
  children: React.ReactNode;
  isLogin?: boolean;
  dontHaveFooter?: boolean;
  footerVariant?: 'default' | 'new';
  newFooterProps?: NewFooterProps;
  // isMinimalFooter?: boolean;
};

export default function DefaultLayout({
  children,
  isLogin,
  dontHaveFooter = false,
  footerVariant = 'default',
  newFooterProps,
  // isMinimalFooter = false,
}: Props) {
  const isDown700 = useMediaQuery('(max-width: 700px)');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header isLogin={isLogin} />

      <Box
        bgcolor="#FFF"
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
        }}
      >
        {children}
      </Box>

      {!dontHaveFooter && footerVariant === 'new' && <NewFooter {...newFooterProps} />}
      {!dontHaveFooter && footerVariant === 'default' && !isDown700 && <Footer />}
      {!dontHaveFooter && footerVariant === 'default' && isDown700 && <VerticalFooter />}
      {/* {!dontHaveFooter && isMinimalFooter && <MinimalFooter />} */}
    </Box>
  );
}
